import { action, observable } from 'mobx'
import { WeekConsumptionStore } from './WeekConsumptionStore'
export const LOADER_STATUS_IDLE = 0
export const LOADER_STATUS_LOADING = 1
export const LOADER_STATUS_VALIDATE = 2

export interface ILayoutStore {
  debugMode: boolean
  arianeFeedStepCount: number
  currentStep: number
  loaderStatus: number
  isBig: boolean
  modalIsVisible: boolean
  resultConsumptionIsVisible: boolean
  incrementArianeFeedStepCount(): void
  incrementStep(): void
  changeLoaderStatus(status: number): void
  setArianeFeedStepCount(count: number): void
  setStep(stepIndex: number): void
  setDebugMode(mode: boolean): void
  toggleBigText(): void
  toggleModal(): void
  reset(): void
  fullReset(): void
  showResultConsumption(): void
  hideResultConsumption(): void
}

export class ClassLayoutStore implements ILayoutStore {
  @observable public arianeFeedStepCount = 0
  @observable public currentStep = 0
  @observable public loaderStatus = LOADER_STATUS_IDLE
  @observable public debugMode = false
  @observable public isBig = false
  @observable public modalIsVisible = false
  @observable public resultConsumptionIsVisible = false

  // Since toggleBigText is used in a onClick handler, we need to bind the current Context to the action
  // Otherwise this will be undefined since onClick does not provide any this context
  @action.bound public toggleBigText(): void {
    this.isBig = !this.isBig
    if (this.isBig) {
      document.querySelector('html').classList.add('isBig')
    } else {
      document.querySelector('html').classList.remove('isBig')
    }
  }

  @action.bound public showResultConsumption(): void {
    this.resultConsumptionIsVisible = true
  }

  @action.bound public hideResultConsumption(): void {
    this.resultConsumptionIsVisible = false
  }

  @action.bound public toggleModal(): void {
    this.modalIsVisible = !this.modalIsVisible
    this.modalIsVisible
      ? document.querySelector('body').classList.add('overflowHidden')
      : document.querySelector('body').classList.remove('overflowHidden')
  }

  @action public incrementArianeFeedStepCount(): void {
    this.arianeFeedStepCount++
  }

  @action public incrementStep(): void {
    this.currentStep++
  }

  @action public setArianeFeedStepCount(count: number): void {
    this.arianeFeedStepCount = count
  }

  @action public setStep(stepIndex: number): void {
    this.currentStep = stepIndex
    if (stepIndex < 5) {
      WeekConsumptionStore.setCurrentDayIndex(0)
    }
  }

  @action public changeLoaderStatus(status: number): void {
    if (
      status === LOADER_STATUS_IDLE ||
      status === LOADER_STATUS_LOADING ||
      status === LOADER_STATUS_VALIDATE
    ) {
      this.loaderStatus = status
    } else {
      Error(
        'Loader status not valid, must be LOADER_STATUS_IDLE, LOADER_STATUS_LOADING or LOADER_STATUS_VALIDATE (see LayoutStore.ts)'
      )
    }
  }

  @action public setDebugMode(mode: boolean): void {
    this.debugMode = mode
  }

  @action public reset(): void {
    this.arianeFeedStepCount = 0
    this.loaderStatus = LOADER_STATUS_IDLE
    this.debugMode = false
  }

  @action public fullReset(): void {
    this.arianeFeedStepCount = 0
    this.currentStep = 0
    this.loaderStatus = LOADER_STATUS_IDLE
    this.debugMode = false
    this.isBig = false
    this.modalIsVisible = false
    this.resultConsumptionIsVisible = false
  }
}

export const LayoutStore = new ClassLayoutStore()



// WEBPACK FOOTER //
// ./src/store/LayoutStore.ts